<template>
  <md-dialog :md-active="dialog.active">
    <md-dialog-title v-if="editMode">
      Edit Promocode Group
    </md-dialog-title>
    <md-dialog-title v-else>
      Generate Promocode Group
    </md-dialog-title>
    <md-dialog-content>
      <form>
        <md-field :class="$v.dialog.form.group.$error && 'md-invalid invalid-field'">
          <label>Group</label>
          <md-input
            v-model="dialog.form.group"
            :disabled="editMode || dialog.isSubmitting"
          />
          <span class="md-helper-text">Name of the group</span>
          <span class="md-error">Field is required</span>
        </md-field>

        <md-field
          v-if="!editMode"
          :class="$v.dialog.form.count.$error && 'md-invalid invalid-field'"
        >
          <label>Count</label>
          <md-input
            v-model="dialog.form.count"
            type="number"
            :disabled="dialog.isSubmitting"
          />
          <span class="md-helper-text">Number of promocodes to generate</span>
          <span class="md-error">Field is required, must be an integer, more than 0</span>
        </md-field>

        <br>
        <label :class="$v.dialog.form.starts_from.$error && 'invalid-field'">Starting date:</label>
        <Datetime
          v-model="dialog.form.starts_from"
          type="date"
          zone="UTC"
          value-zone="UTC"
        />
        <span
          v-if="$v.dialog.form.starts_from.$error"
          class="invalid-field"
        />

        <label :class="$v.dialog.form.valid_until.$error && 'invalid-field'">End date:</label>
        <Datetime
          v-model="dialog.form.valid_until"
          type="date"
          zone="UTC"
          value-zone="UTC"
        />
        <span
          v-if="$v.dialog.form.valid_until.$error"
          class="invalid-field"
        />

        <md-switch
          v-model="dialog.form.isRedeemAllowed"
          :disabled="dialog.isSubmitting"
        >
          Enabled
        </md-switch>

        <md-switch
          v-model="dialog.form.can_be_summed"
          :disabled="dialog.isSubmitting"
        >
          Can be summed
        </md-switch>

        <md-field :class="$v.dialog.form.maximum_redeem_times.$error && 'md-invalid invalid-field'">
          <label>Max redeem times</label>
          <md-input
            v-model="dialog.form.maximum_redeem_times"
            type="number"
            :disabled="dialog.isSubmitting"
          />
          <span class="md-helper-text">How many times a single code can be redeemed</span>
          <span class="md-error">Field is required, must be an integer, more than 0</span>
        </md-field>

        <md-field :class="$v.dialog.premiumDurationDays.$error && 'md-invalid invalid-field'">
          <label>Premium duration</label>
          <md-input
            v-model="dialog.premiumDurationDays"
            :disabled="dialog.isSubmitting"
            @change="onDurationChange"
          />
          <span class="md-suffix">days</span>
          <span class="md-helper-text">{{ dialog.durationHelperText }}</span>
          <span class="md-error">Field must be an integer</span>
        </md-field>
      </form>

      <md-dialog-actions>
        <md-button
          :disabled="dialog.isSubmitting"
          @click="dialog.active = false"
        >
          Close
        </md-button>
        <md-button
          :disabled="dialog.isSubmitting"
          class="md-primary submitButton"
          @click="onSubmit"
        >
          <span v-if="!dialog.isSubmitting">{{ editMode ? 'Update' : 'Generate' }}</span>
          <md-progress-spinner
            v-else
            :md-diameter="18"
            md-mode="indeterminate"
          />
        </md-button>
      </md-dialog-actions>
    </md-dialog-content>
  </md-dialog>
</template>

<script>
import { Datetime } from "vue-datetime";
import {integer, minValue, required, requiredUnless} from "vuelidate/lib/validators";

export default {
  name: "PromocodeGroupDialog",
  components: {Datetime},
  props: {
    dialog: {
      type: Object,
      required: true
    },
    editMode: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    onDurationChange() {
      this.dialog.form.premium_duration_hours = this.dialog.premiumDurationDays * 24;
      this.dialog.durationHelperText = `${this.dialog.form.premium_duration_hours} hours`;
    },
    onSubmit() {
      this.$v.dialog.form.$touch();

      if (this.$v.dialog.$error) {
        return;
      }
      this.dialog.isSubmitting = true;
      this.$emit("submit", {...this.dialog.form, total_redeemable_number: this.dialog.form.maximum_redeem_times });
    }
  },
  validations: {
    dialog: {
      premiumDurationDays: { required, integer },
      form: {
        group: { required },
        count: { required: requiredUnless("editMode"), integer, minValue: minValue(1) },
        starts_from: { required },
        valid_until: { required },
        maximum_redeem_times: { required, integer, minValue: minValue(1) },
      }
    }
  }
};
</script>

<style scoped>
  .submitButton {
    width: 120px;
  }
</style>
